import { render, staticRenderFns } from "./ChooseOrgModal.vue?vue&type=template&id=719710d7&scoped=true&"
import script from "./ChooseOrgModal.vue?vue&type=script&lang=js&"
export * from "./ChooseOrgModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOrgModal.vue?vue&type=style&index=0&id=719710d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719710d7",
  null
  
)

export default component.exports